import RatingQuiz from './RatingQuiz';

export default RatingQuiz;
